import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useChampionTheme } from './ChampionElements';

export default function LearningSidebar({
  webinarId,
  hasEpisodes,
  hasMaterials,
  hasTranscripts,
  hasQuiz,
  hasCertificate
}) {
  const base = `/learning/${webinarId}`;
  const navigate = useNavigate();
  const location = useLocation();
  const t = useChampionTheme();

  const links = [];

  if (hasEpisodes) {
    links.push({ to: `${base}/episodes`, label: 'Episode', icon: 'bi-trophy' });
  }
  if (hasMaterials) {
    links.push({ to: `${base}/materials`, label: 'Materi', icon: 'bi-file-earmark-text' });
  }
  if (hasTranscripts) {
    links.push({ to: `${base}/transcripts`, label: 'Transkrip', icon: 'bi-journal-text' });
  }
  if (hasQuiz) {
    links.push({ to: `${base}/quiz`, label: 'Kuis', icon: 'bi-patch-question' });
  }
  if (hasCertificate) {
    links.push({ to: `${base}/certificate`, label: 'Sertifikat', icon: 'bi-award' });
  }

  if (links.length === 0) return null;

  const handleSelectChange = (e) => {
    if (e.target.value) navigate(e.target.value);
  };

  const activeLink = links.find(link => location.pathname.startsWith(link.to));
  const activeValue = activeLink ? activeLink.to : '';

  const linkStyle = (isActive) => ({
    background: isActive ? `linear-gradient(135deg, ${t.gold}22, ${t.gold}11)` : 'transparent',
    border: isActive ? `1px solid ${t.gold}44` : '1px solid transparent',
    color: isActive ? t.gold : t.textMuted,
    fontWeight: isActive ? 700 : 500,
    borderRadius: '12px',
    marginBottom: '4px',
    padding: '12px 16px',
    transition: 'all 0.3s ease',
    boxShadow: isActive ? `0 0 15px ${t.gold}22` : 'none',
  });

  const sidebarBg = t.isDark
    ? 'linear-gradient(180deg, rgba(26,16,37,0.9), rgba(45,27,78,0.7))'
    : 'linear-gradient(180deg, #FFFFFF, #FFF5E6)';

  return (
    <>
      {/* ── Mobile: select dropdown ── */}
      <select
        className="form-select d-md-none mb-3"
        value={activeValue}
        onChange={handleSelectChange}
        style={{
          backgroundColor: t.bgCard,
          color: t.gold,
          border: `1px solid ${t.gold}44`,
          borderRadius: '12px',
          fontWeight: 600,
        }}
      >
        {links.map(link => (
          <option key={link.to} value={link.to} style={{ backgroundColor: t.bgCard, color: t.text }}>
            {link.label}
          </option>
        ))}
      </select>

      {/* ── Desktop: vertical list-group ── */}
      <div className="list-group list-group-flush d-none d-md-block" style={{
        background: sidebarBg,
        borderRadius: '16px',
        padding: '16px',
        border: `1px solid ${t.border}`,
        backdropFilter: 'blur(10px)',
        transition: 'all 0.4s ease',
      }}>
        <div style={{ color: t.gold, fontWeight: 800, fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '12px', padding: '0 8px' }}>
          <i className="bi bi-stars me-1"></i>Navigasi
        </div>
        {links.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            className="list-group-item list-group-item-action d-flex align-items-center"
            style={({ isActive }) => linkStyle(isActive)}
          >
            <i className={`bi ${link.icon} me-2`}></i>
            {link.label}
          </NavLink>
        ))}
      </div>
    </>
  );
}
